import { getFormattedValidationErrorFromAction } from 'Utils/getFormattedValidationErrorFromAction';

export const FETCH_VENDORS = 'FETCH_VENDORS';
export const FETCH_VENDORS_SUCCESS = `${FETCH_VENDORS}_SUCCESS`;
export const FETCH_VENDORS_FAIL = `${FETCH_VENDORS}_FAIL`;

const initialState = {
  value: [],
  isLoading: false,
  error: null,
  finishRequests: false,
  isError: false,
};

const AvailableVendorsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_VENDORS:
      return {
        ...state,
        isLoading: true,
        finishRequests: false,
        isError: false,
      };
    case FETCH_VENDORS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        finishRequests: true,
        isError: false,
        value: [...action.payload.data],
      };
    case FETCH_VENDORS_FAIL:
      const errorUpdateParticipant =
        getFormattedValidationErrorFromAction(action);

      return {
        ...state,
        isLoading: false,
        finishRequests: true,
        isError: true,
        error: errorUpdateParticipant,
      };
    default:
      return state;
  }
};

export default AvailableVendorsReducer;
